import { Avatar, ListItem, Stack } from "@skailer-com/uikit";
import { ReactNode } from "react";

interface PreboardingTaskRowProps {
  emoji?: string | null;
  icon?: ReactNode;
  title: string;
  caption?: ReactNode;
  action?: ReactNode;
}

export function PreboardingTaskRow({
  emoji,
  icon,
  title,
  caption,
  action,
}: PreboardingTaskRowProps) {
  return (
    <Stack direction={"horizontal"} items={"center"} gap={"smd"}>
      <Avatar size={"md"} emoji={emoji} icon={icon} />
      <ListItem
        className={"min-h-16"}
        title={title}
        captionSlot={caption}
        valueSlot={action}
        behavior={"card"}
      />
    </Stack>
  );
}
